'use strict';
const _ = require('lodash');
const $ = require('jquery');
const Backbone = require('backbone');
const ViewContestant = require('./contestant');
const ViewAd = require('./ad');
const ViewCategorySubmit = require('./category-submit');
const template = require('../templates/category.ejs');
const { isMobile } = require('../util/is-mobile');
module.exports = Backbone.View.extend({
    className: 'flex-container',
    events: {
        'click .btn': 'loadVideo'
    },
    /**
     *
     */
    initialize: function (options) {
        _.bindAll(this, 'render');

        options = options || {};

        this.voteData = null;
        this.recentlyVoted = false;
        this.timeOut = null;
        this.cms = options.cms;
        this.hideAnimation = options.hideAnimation || false;
        this.initialAnimation = _.isUndefined(options.initialAnimation) ? true : options.initialAnimation;
        this.contestantToIncrementID = options.contestantToIncrementID;

        this.dimensions = options.dimensions;
        this.user = options.user;
        this.contestantsArray = [];

        this.copy = options.copy;
        this.transitionTime = (parseInt(this.cms.get('text').customization.transition_time) || 500);

        this.listenTo(this.model, 'change:totalAllocatedVotes', this.updatePlusButtons.bind(this));

        this.listenTo(this.model, 'change:isSubmitted', function(model, isSubmitted) {
          if( isSubmitted ) this.renderedToDom(true);
        }.bind(this));

        this.listenTo(this.model, 'change:categoryVotes', function(model, updatedVoteCounts) {
            this.contestantsArray.forEach( function(view) {
                var model = view.model;
                var contestantId = model.get('id');
                var value = updatedVoteCounts[contestantId];

                if(value) model.set('voteCount', parseInt(value, 10));
            });
        }.bind(this));

    },

    /**
     *
     */
    render: function () {
        var model = this.model.toJSON();
        model.copy = this.copy;
        this.$el.css({height: '0'});
        this.$el.html(template(model));

        var sortedContestants = this.model.get('voteData');
        sortedContestants.sort((a, b) => parseInt(a.order, 10) - parseInt(b.order, 10));

        _.forEach(sortedContestants, function(value) {

            var voteCount = this.model.get('categoryVotes')[value.id] ? this.model.get('categoryVotes')[value.id] : 0;
            var contestantModel = new Backbone.Model(_.extend({ voteCount: voteCount }, value));
            var toBeIncremented = this.contestantToIncrementID === value.id;

            var contestant = new ViewContestant({
                cms: this.cms,
                model: contestantModel,
                user: this.user,
                dimensions: this.dimensions,
                person: this.model.get('person'),
                copy: this.copy,
                professional: this.model.get('professional'),
                social: this.model.get('social'),
                customization: this.cms.get('text').customization,
                category: this.model
            });

            this.contestantsArray.push(contestant);
            this.$('.contestants-wrapper').append(contestant.render().$el);
            contestant.renderedToDom(toBeIncremented);

        }.bind(this));

        this.updatePlusButtons(this.model);
        this.contestantToIncrementID = null;
        return this;
    },
    /**
     * [renderedToDom description]
     * @return {[type]} [description]
     */
    renderedToDom: function(update) {

        // add the submit button below the category
        if(!this.model.get('isSubmitted') && this.model.get('professional') === '0' && this.model.get('active') === '1') {
            var voteLimit = this.cms.turboVote.get('voteLimit');
            var votesRemaining = voteLimit - this.model.get('totalAllocatedVotes');
            this.categorySubmitView = new ViewCategorySubmit({
                model: this.model,
                voteLimit: voteLimit,
                votesRemaining: votesRemaining
            });
            this.$el.removeClass('submitted');
            this.$el.after(this.categorySubmitView.render().$el);
        } else {
            //If we don't need the category submit view, let's remove it.
            if(this.categorySubmitView && update) this.categorySubmitView.remove();
        }

        if(this.model.get('isSubmitted')) {
            this.$el.addClass('submitted');
        }

        this.$el.parent().css({height: '0px'});

        if(parseInt(this.model.toJSON().person)) {
            this.$el.parent().addClass('circle');
        }

        if(_.checkIfTrue(this.model.get('display_ad')) && !update) {
            this.renderAd();
        }

        if(!this.hideAnimation && this.initialAnimation && !update) {
            this.scrollAnimation();
        } else {
            this.$el.parent().css({height: 'auto'});
            this.$el.css({height: 'auto'});
        }
    },
    /**
     * [renderAd description]
     * @return {[type]} [description]
     */
    renderAd: function () {

        if(this.adView instanceof ViewAd) return;

        this.adView = new ViewAd({
            categoryIndex: this.model.get('id'),
            adTag: this.model.get('ad_tag') || this.model.get('displayName'),
            model: this.model.get('ad'),
        });

        var contestantEls = this.$el.find('.contestant');
        if(contestantEls.length > 0) {
          $(contestantEls[contestantEls.length - 1]).after(this.adView.render().$el)
        } else {
          this.$el.append(this.adView.render().$el);
        }

        this.adView.renderedToDom();
    },
    /**
     * When there are no more votes remaining, disable all the plus buttons
     */
    updatePlusButtons: function(model) {
        var totalAllocatedVotes = model.get('totalAllocatedVotes');
        var voteLimit = parseInt(this.cms.turboVote.get('voteLimit'), 10);
        if(totalAllocatedVotes === voteLimit) {
            model.updatePlusButtons();
        }
    },

    /**
     * [scrollAnimation description]
     * @return {[type]} [description]
     */
    scrollAnimation: function() {
        const categoryButton = document.querySelector('.category-button[data-category-id="' + this.model.get('id') + '"]');
        const buttonTop = categoryButton.offsetTop;
        const mobileMenuHeight = isMobile.any() ?
                        document.getElementById('header').offsetHeight : 
                        document.getElementById('mtv-mobile-menu').offsetHeight;
        const hasSkybox = document.body.classList.contains('skybox-loaded');
        let skyboxHeight = 0;

        if( hasSkybox ) {
            skyboxHeight = isMobile.any() ?
                        document.querySelector('#mobile_skybox_plus_sticky iframe').offsetHeight :
                        document.querySelector('#skybox_leader_plus_sticky iframe').offsetHeight;
        }

        $('html,body').animate({
            scrollTop: buttonTop - mobileMenuHeight - skyboxHeight
        }, {
            duration: 200,
            complete: function() {
                // fixes issue when the function runs twice due to HTML and body attributes
                if(/(auto)/.test(this.$el.parent().attr('style'))) {
                    return false;
                }
    
                this.$el.parent().css({height: 'auto'});
                this.$el.animate({
                    height: '1200px'
                }, this.transitionTime, function() {
    
                    $(this).css({height: 'auto'});
    
                })
            }.bind(this)
        });
    },
    /**
     * [remove description]
     * @return {[type]} [description]
     */
    remove: function() {
        // remove the various Contestants views from the contestants array
        _.forEach(this.contestantsArray, function(value, index) { value.remove(); });

        if(this.categorySubmitView) this.categorySubmitView.remove();

        this.contestantsArray = null;

        this.voteData = null;

        if(this.adView) {
            this.adView.remove();
            this.adView = null;
        }

        this.stopListening();
        this.off();

        this.model = null;
        this.copy = null;

        this.recentlyVoted = false;
        this.closedTextDisplayed = false;

        if(typeof this.timeOut == 'number') { clearTimeout(this.timeOut); console.warn('cancel timeout') };

        if(typeof this.removeClosedText == 'number') { clearTimeout(this.removeClosedText); console.warn('cancel timeout') };

        return Backbone.View.prototype.remove.call(this);
    }
});


// WEBPACK FOOTER //
// ./app/scripts/views/category.js